import { PaymentRequirementsHistoryState } from "./interface";

export default <PaymentRequirementsHistoryState> {
	historyList: [],
	historyListLoading: false,
	historyPageIsEnd: false,
	historyFilters: {
		income: null,
		searchDateBegin: null,
		searchDateEnd: null,
		status: null,
		paymentSum: null,
		recipientAccount: null,
		requesterAccount: null,
		elementsOnPage: null,
		pageNumber: null
	}
}